var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer bg-yellow p-20 flex"},[_c('app-footer-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }